export default {
    actions: {
        uploadImage(store, { file, onUploadProgress }) {

            let formData = new FormData();

            formData.append('file', file);

            return this.dispatch('sendRequest', {
                path: '/media/image',
                data: formData,
                method: 'post',
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress
            })
        }
    }
}